import {
  Breadcrumbs,
  Button,
  Card,
  Container,
  Icon,
  Section,
  Stack,
} from "@storoey/sui";
import { createFileRoute, useNavigate } from "@tanstack/solid-router";
import { onMount } from "solid-js";
import { useNavbar } from "../../../../../contexts/RootContext";
import {
  generateZip,
  getTimestamp,
  removeExtension,
  sanitizePath,
} from "../../../../../utils/generate-zip";

export const Route = createFileRoute(
  "/history/$formId/$categoryId/$sectionId/results"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const loaderData = Route.parentRoute.useLoaderData();

  const { setTitle } = useNavbar();
  const navigate = useNavigate();

  onMount(() => {
    setTitle("Oppsumering");
  });

  const download = async () => {
    // window.swetrix.track({
    //   ev: "DOWNLOAD_RESULT",
    //   unique: false,
    // });
    const blob = await generateZip({ formId: loaderData().formId });

    const fileName = removeExtension(loaderData().formName);

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = sanitizePath(`${fileName}_${getTimestamp()}.zip`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Section
      padding="lg"
      breadcrumbs={
        <Container>
          <Breadcrumbs>
            <Breadcrumbs.Item onClick={() => navigate({ to: `/` })}>
              Hjem
            </Breadcrumbs.Item>
            <Breadcrumbs.Item onClick={() => navigate({ to: `/history` })}>
              Historie
            </Breadcrumbs.Item>
            <Breadcrumbs.Item
              onClick={() =>
                navigate({ to: `/history/` + loaderData().formId })
              }
            >
              {loaderData().formName}
            </Breadcrumbs.Item>
            <Breadcrumbs.Item
              onClick={() =>
                navigate({
                  to:
                    `/history/` +
                    loaderData().formId +
                    "/" +
                    loaderData().categoryId,
                })
              }
            >
              {loaderData().categoryName}
            </Breadcrumbs.Item>
            <Breadcrumbs.Item
              onClick={() =>
                navigate({
                  to:
                    `/history/` +
                    loaderData().formId +
                    "/" +
                    loaderData().categoryId +
                    "/" +
                    loaderData().section.id,
                })
              }
            >
              {loaderData().section.title}
            </Breadcrumbs.Item>
            <Breadcrumbs.Item current>Oppsumering</Breadcrumbs.Item>
          </Breadcrumbs>
        </Container>
      }
    >
      <Container>
        <Stack>
          <Card elevation={200}>
            <Card.Content>
              <Card.Title>Oppsummering</Card.Title>
              <Card.Text>
                Nedenfor finner du en oppsummering av resultatet. For å laste
                ned resultatet, trykk på knappen under.
              </Card.Text>
            </Card.Content>
            <Card.Actions align="end">
              <Button rightIcon={<Icon>download</Icon>} onClick={download}>
                Last ned
              </Button>
            </Card.Actions>
          </Card>
        </Stack>
      </Container>
    </Section>
  );
}
